"use client";
import { j as l } from "./jsx-runtime-CJ-St4mQ.mjs";
import { u as N, n as d } from "./NavigationMenu.style-Dq96CLFG.mjs";
import * as c from "react";
import { C as g } from "./CompositeRoot-DqjHHBWD.mjs";
const u = /* @__PURE__ */ c.forwardRef(function(t, o) {
  const {
    className: e,
    render: a,
    ...n
  } = t, {
    orientation: r,
    open: p
  } = N(), m = c.useMemo(() => ({
    open: p
  }), [p]), f = {
    // `stopEventPropagation` won't stop the propagation if the end of the list is reached,
    // but we want to block it in this case.
    onKeyDown(s) {
      (r === "horizontal" && (s.key === "ArrowLeft" || s.key === "ArrowRight") || r === "vertical" && (s.key === "ArrowUp" || s.key === "ArrowDown")) && s.stopPropagation();
    }
  };
  return /* @__PURE__ */ l.jsx(g, {
    render: a,
    className: e,
    state: m,
    refs: [o],
    props: [f, n],
    loop: !1,
    orientation: r,
    stopEventPropagation: !0
  });
});
process.env.NODE_ENV !== "production" && (u.displayName = "NavigationMenuList");
const x = (i) => {
  const { children: t, className: o, role: e = "menu", ...a } = i, n = typeof o == "function" ? o({ open: !1 }) : o;
  return /* @__PURE__ */ l.jsx(
    u,
    {
      className: d({ class: n }),
      role: e,
      ...a,
      children: t
    }
  );
};
export {
  x as default
};
